// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3pBM9","label":"LabeledBox_label__1QuFj"};